import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { auctionsApi, type AuctionBidListParams } from '../api/auctions-api';
import { LIVE_POLL_MS } from '../schemas/auction-rules';

import { auctionKeys } from './auction-keys';

export function auctionBidsQueryOptions(
  storeId: string,
  id: string,
  params: AuctionBidListParams,
  live = false,
) {
  return queryOptions({
    queryKey: auctionKeys.bids(storeId, id, params),
    queryFn: () => auctionsApi.bids(storeId, id, params),
    placeholderData: keepPreviousData,
    refetchInterval: live ? LIVE_POLL_MS : false,
  });
}

/** Newest first; refetched on the detail's beat while the auction is live. */
export function useAuctionBids(
  storeId: string,
  id: string,
  params: AuctionBidListParams,
  live: boolean,
) {
  return useQuery(auctionBidsQueryOptions(storeId, id, params, live));
}
